import React, { useState } from "react";
import "./kicker.css";
import baby from "../../assets/babyst.png";
import kick from "../../assets/kickfoot.png";
import right from "../../assets/right.png";
import left from "../../assets/left.png";
import { Link } from "react-router-dom";

function ShowKicker() {
  const [count, setCount] = useState(18);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [extraCounts, setExtraCounts] = useState(0);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);

  const defaultColors = Array(10).fill("#fff");
  const [buttonColors, setButtonColors] = useState(defaultColors);
  const currentDate = new Date().toLocaleDateString();
  const handleKick = () => {
    const newColors = [...buttonColors];

    if (currentIndex < 10) {
      if (currentIndex === 0 && startTime === null) {
        const startTimeNow = new Date().toLocaleTimeString();
        setStartTime(startTimeNow);
        localStorage.setItem("startTime", startTimeNow);
      }

      newColors[currentIndex] = "#B24C76";
      setButtonColors(newColors);
      setCurrentIndex(currentIndex + 1);
    } else {
      setExtraCounts(extraCounts + 1);
    }
  };

  const reduceOneClick = () => {
    if (extraCounts > 0) {
      setExtraCounts(extraCounts - 1);
    } else if (currentIndex > 0) {
      const newColors = [...buttonColors];
      newColors[currentIndex - 1] = "#fff";
      setButtonColors(newColors);
      setCurrentIndex(currentIndex - 1);
    }
  };

  const stopCountingKicks = () => {
    const endTime = new Date().toLocaleTimeString();
    setEndTime(endTime);

    const data = {
      currentDate,
      startTime,
      endTime,
      totalKicks: currentIndex + extraCounts,
    };

    let kickDataArray = JSON.parse(localStorage.getItem("kickDataArray")) || [];

    kickDataArray.push(data);

    localStorage.setItem("kickDataArray", JSON.stringify(kickDataArray));
  };

  return (
    <div style={{ backgroundColor: "#B24C76" }} className="kicker-base">
      <div style={{ backgroundColor: "white" }} className="main-kick">
        <div className="kicker-container">
          <a href="/kick-timer">
            <button id="left-btn">
              <img
                src={left}
                className="right-ar"
                style={{
                  animation: "bouncer 1s infinite",
                  marginRight: "20px",
                  marginTop: "-4px",
                }}
              />
              Kicker Details
            </button>
          </a>

          <Link
            to={{
              pathname: "previous-chart",
              state: {
                date: currentDate,
                startTime: startTime,
                endTime: endTime,
                totalKicks: currentIndex,
              },
            }}
          >
            <button id="right-btn">
              Kicker Chart
              <img
                src={right}
                className="right-ar"
                style={{
                  animation: "bouncer 1s infinite",
                  marginLeft: "20px",
                  marginTop: "-4px",
                }}
              />
            </button>
          </Link>
        </div>
        <div className="main-cont">
          <h2 style={{ color: "#B24C76", textAlign: "center" }}>
            Baby Kick Timer
          </h2>
          <p style={{ textAlign: "center", color: "black" }}>
            The Kicks, rolls/wiggles will evolve throughout your pregnancy and
            with the Kick timer you are able to record the number of kicks.
          </p>
          <p
            style={{ textAlign: "center", color: "black" }}
            className="need-to-center"
          >
            Counting 10 movements of any kind in one to two hours tends to be
            the norm, though sometimes it can take longer.
          </p>

          <img src={baby} alt="Trigger" className="baby-butterfly" />

          <h4 style={{ color: "#B24C76", marginTop: "20px" }}>
            {" "}
            You are at week {count}
          </h4>
          <p style={{ color: "black" }}>
            You may feel like Butterflies fluttering in your belly at this stage
          </p>
          <div className="time-laper">
            <p style={{ fontWeight: "bold", color: "black" }}>
              Started Time:{" "}
              <span style={{ color: "#B24C76", fontWeight: "bold" }}>
                {startTime || "__"}
              </span>
            </p>
            <p style={{ fontWeight: "bold", color: "black" }}>
              {" "}
              End Time:{" "}
              <span style={{ color: "#B24C76", fontWeight: "bold" }}>
                {endTime || "__"}
              </span>{" "}
            </p>
          </div>
        </div>
        <div className="nums">
          {buttonColors.map((color, index) => (
            <button
              key={index}
              style={{
                backgroundColor: color,
                border: "1px solid #ccc",

                cursor: "pointer",
              }}
            >
              {index + 1}
            </button>
          ))}
        </div>
        {currentIndex === buttonColors.length && (
          <div
            style={{
              marginTop: "50px",
              color: "#B24C76",
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "18px",
            }}
          >
            {10 + extraCounts} counts
          </div>
        )}
        <div className="kick-time">
          <button id="time1" onClick={reduceOneClick}>
            <span style={{ fontWeight: "bold" }}>-1 count</span>
          </button>
          <div id="time2" onClick={handleKick}>
            <img src={kick} />
          </div>
          <Link
            to={{
              pathname: "chart",
              state: {
                startTime: startTime,
                endTime: endTime,
                totalKicks: currentIndex,
              },
            }}
          >
            <button
              id="time3"
              style={{ background: "#F07474", color: "white" }}
              onClick={stopCountingKicks}
            >
              Stop Counting Kicks
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ShowKicker;
